import { CardIdea } from "./CardIdea";
export default CardIdea;
